<template>
    <div>
        <v-col cols="12" md="8" lg="12" class="pa-0 ma-0">
            <p class="text-body-medium">
                All ArupCompute functions can be called from Python. The
                <a href="/docs/python/" target="_blank" class="text-accent">
                    documentation shows how to install the arupcomputepy package
                    and full usage instructions
                </a>
                .
            </p>
            <p class="text-body-medium">
                The below snippet shows how to call this calculation once.
            </p>
        </v-col>
        <CodeBox :text="pythonCode" />
    </div>
</template>
<script setup>
import { computed } from 'vue'
import CodeBox from './CodeBox.vue'

const props = defineProps(['calc'])

const pythonCode = computed(() => {
    let lines = []
    lines.push('import arupcomputepy')
    lines.push('')
    lines.push("jobNumber = '00000000' # insert real job number")
    lines.push('connection = arupcomputepy.Connection(jobNumber)')
    lines.push('')
    lines.push('# ' + props.calc.name)
    lines.push('# ' + props.calc.description)
    lines.push('')
    if (props.calc.persistentCalcID) {
        lines.push("persistentCalcID = '" + props.calc.persistentCalcID + "'")
    } else {
        lines.push('calcID = ' + props.calc.calcId)
    }
    lines.push('')
    lines.push('variables = {')

    let idx = 0
    for (var input of props.calc.inputs) {
        let variableLine = "    '" + input.name + "': value"
        if (idx != props.calc.inputs.length - 1)
            variableLine = variableLine + ','
        variableLine = variableLine + ' # ' + input.description
        if (input.units) {
            variableLine = variableLine + ' (' + input.units + ')'
        }
        lines.push(variableLine)
        idx = idx + 1
    }
    lines.push('}')
    lines.push('')
    if (props.calc.persistentCalcID) {
        lines.push(
            'response = arupcomputepy.MakeCalculationRequest(connection, persistentCalcId=persistentCalcID, isBatch=False, variables=variables)'
        )
    } else {
        lines.push(
            'response = arupcomputepy.MakeCalculationRequest(connection, calcID, isBatch=False, variables=variables)'
        )
    }
    lines.push('')

    if (props.calc.persistentCalcID) {
        lines.push(
            '# We can also execute a calculation using its calc ID (ie. an ID that is specific to this library version):'
        )
        lines.push('# calcID = ' + props.calc.calcId)
        lines.push(
            `# response = arupcomputepy.MakeCalculationRequest(connection, calcID, isBatch=False, variables=variables)`
        )
        lines.push('')
    }

    if (!(props.calc.outputs === undefined || props.calc.outputs == 0)) {
        lines.push('# Available output values:')
        for (var output of props.calc.outputs) {
            let line = `${output.name} = response['${output.name}'] # ${output.description}`
            if (output.units) {
                line = line + ' (' + output.units + ')'
            }
            lines.push(line)
        }
    } else {
        lines.push('print(response)')
    }

    return lines.join('\n')
})
</script>
